import { generatePath } from 'react-router-dom';
import * as ROUTE_TEMPLATES from '../constants/routeTemplates';

export const getRootRoute = () => ROUTE_TEMPLATES.ROOT;
export const getFilterRoute = () => ROUTE_TEMPLATES.FILTER;
export const getSearchRoute = () => ROUTE_TEMPLATES.SEARCH;
export const getFavoritesRoute = () => ROUTE_TEMPLATES.FAVORITES;
export const getRecentGamesRoute = () => ROUTE_TEMPLATES.RECENT_GAMES;

export const getProvidersRoute = () => ROUTE_TEMPLATES.PROVIDER_LIST;
export const getProviderDetailRoute = (providerId = '') =>
  ROUTE_TEMPLATES.PROVIDER_DETAIL.replace(':providerId', providerId);

export const getCategoriesRoute = () => ROUTE_TEMPLATES.CATEGORY_LIST;
export const getCategoryDetailRoute = (categoryId = '') =>
  ROUTE_TEMPLATES.CATEGORY_DETAIL.replace(':categoryId', categoryId);

export const getThemesRoute = () => ROUTE_TEMPLATES.THEME_LIST;
export const getThemeDetailRoute = (themeId = '') =>
  ROUTE_TEMPLATES.THEME_DETAIL.replace(':themeId', themeId);

export const getCurrentBonusesRoute = () => ROUTE_TEMPLATES.BONUSES_LIST;
export const getBonusesHistoryRoute = () => ROUTE_TEMPLATES.BONUSES_HISTORY;

export const getHallOfFameRoute = () => ROUTE_TEMPLATES.HALL_OF_FAME;
export const getHallOfFameHistoryRoute = () =>
  ROUTE_TEMPLATES.HALL_OF_FAME_HISTORY;

export const getBonusDetailRoute = (bonusId = '') =>
  ROUTE_TEMPLATES.BONUS_DETAIL.replace(':bonusId', bonusId);
export const getEmptyBonusDetailRoute = () =>
  ROUTE_TEMPLATES.BONUS_DETAIL.replace('/:bonusId', '');
export const getCampaignDetailRoute = (campaignId = '') =>
  ROUTE_TEMPLATES.CAMPAIGN_DETAIL.replace(':campaignId', campaignId);
export const getEmptyCampaignDetailRoute = () =>
  ROUTE_TEMPLATES.CAMPAIGN_DETAIL.replace('/:campaignId', '');

export const getBonusGamesWageringRoute = () =>
  ROUTE_TEMPLATES.BONUS_GAMES_WAGERING;
export const getBonusGamesCollectingRoute = (campaignId = '') =>
  ROUTE_TEMPLATES.BONUS_GAMES_COLLECTING.replace(':campaignId', campaignId);

export const getGameDetailRoute = (gameId = '') =>
  ROUTE_TEMPLATES.GAME_DETAIL.replace(':gameId', gameId);
export const getDemoGameDetailRoute = (gameId = '') =>
  ROUTE_TEMPLATES.DEMO_GAME_DETAIL.replace(':gameId', gameId);

export const getServerErrorRoute = (status = 500) =>
  generatePath(ROUTE_TEMPLATES.COMMON_ERROR, { status });
